import React from 'react';
import { Mutation } from '@apollo/client/react/components';

import FollowEntityOnboardingMutation from 'buyside/graphql/mutations/FollowEntityOnboarding.graphql';

import OnboardingTickerSuggestionCard from 'buyside/components/presentation/Onboarding/OnboardingForm/OnboardingTickerSuggestionCard/onboardingTickerSuggestionCard';

const OnboardingTickerSuggestionCardContainer = props => (
  <Mutation mutation={FollowEntityOnboardingMutation}>
    {followEntity => <OnboardingTickerSuggestionCard followEntity={followEntity} {...props} />}
  </Mutation>
);

export default OnboardingTickerSuggestionCardContainer;
